"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = require("redux-saga/effects");
var api_types_1 = require("./api.types");
var makeApiRequest = function (config) { return function (_a) {
    var method = _a.method, endpoint = _a.endpoint, body = _a.body, server = _a.server, headers = _a.headers;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, appUserId, computedHeaders, options, e;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    token = undefined;
                    appUserId = undefined;
                    if (!config.getToken) return [3 /*break*/, 2];
                    return [4 /*yield*/, config.getToken()];
                case 1:
                    token = _c.sent();
                    _c.label = 2;
                case 2:
                    if (!config.getAppUserId) return [3 /*break*/, 4];
                    return [4 /*yield*/, config.getAppUserId()];
                case 3:
                    appUserId = _c.sent();
                    _c.label = 4;
                case 4: return [4 /*yield*/, (config.getHeaders
                        ? config.getHeaders({ endpoint: endpoint })
                        : Promise.resolve({}))];
                case 5:
                    computedHeaders = _c.sent();
                    computedHeaders = __assign(__assign({}, headers), computedHeaders);
                    options = {
                        method: method,
                        headers: __assign(__assign(__assign(__assign({}, (appUserId === undefined
                            ? {}
                            : {
                                'x-app-user-id': appUserId,
                            })), (token === undefined
                            ? {}
                            : (_b = {},
                                _b[config.tokenKey || 'x-access-token'] = token,
                                _b))), { Accept: 'application/json' }), computedHeaders),
                        body: body,
                    };
                    e = endpoint.endsWith('/')
                        ? endpoint.slice(0, endpoint.length - 1)
                        : endpoint;
                    if (config.debug) {
                        console.log("" + (server || config.baseUrl) + e, options);
                    }
                    return [2 /*return*/, fetch("" + (server || config.baseUrl) + e, options)];
            }
        });
    });
}; };
var configuireRestApi = function (config) {
    return function callRestApi(action) {
        var _a, types, meta, endpoint, body, headers, method, delay, server, raw, _b, resRaw, timeout, failure, payload, failure, action_1, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = action.payload, types = _a.types, meta = _a.meta, endpoint = _a.endpoint, body = _a.body, headers = _a.headers, method = _a.method, delay = _a.delay, server = _a.server;
                    if (config.debug) {
                        console.log('frr-redux: REDUX ACTION: ', action);
                    }
                    return [4 /*yield*/, effects_1.put({
                            type: types.request,
                            payload: undefined,
                            meta: meta,
                        })];
                case 1:
                    _c.sent();
                    if (!(delay !== undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, effects_1.delay(delay)];
                case 2:
                    _c.sent();
                    _c.label = 3;
                case 3:
                    raw = undefined;
                    _c.label = 4;
                case 4:
                    _c.trys.push([4, 13, , 15]);
                    return [4 /*yield*/, effects_1.race({
                            raw: makeApiRequest(config)({
                                method: method,
                                endpoint: endpoint,
                                body: body,
                                server: server,
                                headers: headers,
                            }),
                            timeout: effects_1.delay(config.timeout || 10000),
                        })];
                case 5:
                    _b = _c.sent(), resRaw = _b.raw, timeout = _b.timeout;
                    raw = resRaw;
                    if (!!raw) return [3 /*break*/, 7];
                    failure = {
                        type: types.failure,
                        payload: {},
                        meta: meta,
                    };
                    if (config.debug) {
                        console.log('frr-redux: TIMEOUT: ', action);
                    }
                    return [4 /*yield*/, effects_1.put(failure)];
                case 6:
                    _c.sent();
                    _c.label = 7;
                case 7: return [4 /*yield*/, raw.json()];
                case 8:
                    payload = _c.sent();
                    if (!(raw.status >= 400)) return [3 /*break*/, 10];
                    failure = {
                        type: types.failure,
                        payload: payload,
                        meta: __assign({ error: payload }, (meta || {})),
                    };
                    if (config.debug) {
                        console.log('frr-redux: FAILURE: ', failure);
                    }
                    return [4 /*yield*/, effects_1.put(failure)];
                case 9:
                    _c.sent();
                    return [3 /*break*/, 12];
                case 10:
                    action_1 = {
                        type: types.success,
                        payload: payload,
                        meta: meta,
                    };
                    if (config.debug) {
                        console.log('frr-redux: SUCCESS: ', action_1);
                    }
                    return [4 /*yield*/, effects_1.put(action_1)];
                case 11:
                    _c.sent();
                    _c.label = 12;
                case 12: return [3 /*break*/, 15];
                case 13:
                    error_1 = _c.sent();
                    if (config.debug) {
                        console.log('frr-redux: TRY CATCH: ', error_1, raw);
                    }
                    return [4 /*yield*/, effects_1.put({
                            type: types.failure,
                            payload: {},
                            meta: __assign(__assign({}, (raw ? { failureStatus: raw.status } : {})), (meta || {})),
                        })];
                case 14:
                    _c.sent();
                    return [3 /*break*/, 15];
                case 15: return [2 /*return*/];
            }
        });
    };
};
exports.configureApiSaga = function (config) {
    return function ApiSaga() {
        var callRestApi;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    callRestApi = configuireRestApi(config);
                    return [4 /*yield*/, effects_1.takeEvery(api_types_1.SystemActionType.REST_CALL, callRestApi)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    };
};
//# sourceMappingURL=rest.saga.js.map